import { RadioGroup, RadioGroupItem, Text } from '@/ui'
import { TypographyStyles } from '@/styles'

interface BinaryRadioGroupProps {
  label: string
  text: string
  name: string
  onChange: (value: boolean) => void
  value: boolean | undefined
}

export const BinaryRadioGroup = ({
  label,
  text,
  name,
  onChange,
  value,
}: BinaryRadioGroupProps) => {
  return (
    <div className="space-y-2">
      <Text variant={TypographyStyles.H3}>
        <b>{label}</b>
      </Text>
      <Text variant={TypographyStyles.BODY_SM}>{text}</Text>
      <RadioGroup
        value={value === true ? 'yes' : value === false ? 'no' : undefined}
        onValueChange={(val) => onChange(val === 'yes')}
        name={name}
        className="pt-2 space-y-2"
      >
        <RadioGroupItem value="yes" label="Yes" />
        <RadioGroupItem value="no" label="No" />
      </RadioGroup>
    </div>
  )
}

export default BinaryRadioGroup
